import request from '@/libs/request';
import RSA from '@/libs/rsa';
import md5 from 'md5';

import config from '@/config';
const baseUrl = config.api_base;

/**
 * 我的信息
 * @param {*} params
 * @returns
 */
export const MyInfo = params => {
  return request('get', `${baseUrl}/api/auth/sys/user/owner/info`, params);
};

/**
 * 更新基本信息
 */
export const EditMyBaseInfo = data => {
  return request('post', `${baseUrl}/api/auth/sys/user/owner/edit`, data);
};

/**
 * 更新邮箱
 */
export const EditMyEmail = data => {
  // 密码加密
  data.password = RSA.encrypt(md5(data.password));

  return request('post', `${baseUrl}/api/auth/sys/user/owner/email`, data);
};

/**
 * 更新密码
 */
export const EditMyPassword = data => {
  // 密码加密
  data.newPwd = RSA.encrypt(md5(data.newPwd));
  data.oldPwd = RSA.encrypt(md5(data.oldPwd));

  return request('post', `${baseUrl}/api/auth/sys/user/owner/pwd`, data);
};
